'use strict';

var React = require('react');

var SvgAnalyticsBarHorizontalMinor = function SvgAnalyticsBarHorizontalMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16a1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1Zm3-4a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1Zm3-4a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h9a1 1 0 0 0 1-1Zm3-4a1 1 0 0 0-1-1h-12a1 1 0 1 0 0 2h12a1 1 0 0 0 1-1Z"
  }));
};

exports.SvgAnalyticsBarHorizontalMinor = SvgAnalyticsBarHorizontalMinor;
